document.addEventListener('DOMContentLoaded', function () {
	const generateBtn = document.getElementById('generate-password-btn');
	const toggleBtn = document.getElementById('toggle-password-btn');
	const passwordField = document.getElementById('id_password');
	const csrf = document.querySelector('input[name="csrfmiddlewaretoken"]');

	// Password visibility toggle
	if (toggleBtn && passwordField) {
		toggleBtn.addEventListener('click', function () {
			const iconShow = this.querySelector('#pwshow');
			const iconHide = this.querySelector('#pwhide');

			if (passwordField.type === 'password') {
				passwordField.type = 'text';
				iconShow.classList.add('d-none');
				iconShow.classList.remove('d-inline');
				iconHide.classList.add('d-inline');
				iconHide.classList.remove('d-none');
			} else {
				passwordField.type = 'password';
				iconShow.classList.remove('d-none');
				iconShow.classList.add('d-inline');
				iconHide.classList.remove('d-inline');
				iconHide.classList.add('d-none');
			}
		});
	}

	// Password generation
	if (generateBtn && passwordField && csrf) {
		generateBtn.addEventListener('click', function () {
			fetch('/users/generate-password/', {
				method: 'POST',
				headers: {
					'X-CSRFToken': csrf.value,
					'Content-Type': 'application/json',
				},
			})
				.then(response => response.json())
				.then(data => {
					if (data.password) {
						passwordField.value = data.password;

						// Automatically show the password when generated
						if (passwordField.type === 'password' && toggleBtn) {
							passwordField.type = 'text';
						}
					}
				})
				.catch(error => {
					console.error('Error generating password:', error);
				});
		});
	}
});